export const sampleData = {
  hero1: {
    brandTitle: "Brand Name",
    title: "Your Main Product Headline",
    description:
      "A compelling description of your product or service that draws users in",
    button: { title: "Get Started", url: "https://stack.je" },
    logo: {
      src: "https://placehold.co/128x128",
      alt: "Brand logo",
    },
    socialLinks: [
      { platform: "instagram" as const, url: "https://instagram.com/brand", displayName: "@brand" },
      { platform: "x" as const, url: "https://x.com/brand", displayName: "@brand" },
      { platform: "email" as const, url: "mailto:hello@example.com", displayName: "Contact us" },
    ],
  },
  hero2: {
    brandTitle: "Brand Name",
    title: "Your Main Product Headline",
    description:
      "A compelling description of your product or service that draws users in",
    logo: {
      src: "https://placehold.co/128x128",
      alt: "Brand logo",
    },
    image: {
      src: "https://placehold.co/150",
      alt: "Hero 2",
    },
    button: { title: "Get Started", url: "https://stack.je" },
    socialLinks: [
      { platform: "instagram" as const, url: "https://instagram.com/brand", displayName: "@brand" },
      { platform: "youtube" as const, url: "https://youtube.com/@brand", displayName: "@brand" },
      { platform: "whatsapp" as const, url: "https://wa.me/1234567890", displayName: "Chat with us" },
    ],
  },
  hero3: {
    brandTitle: "Personal Brand",
    title: "John Smith",
    description:
      "Creative designer and entrepreneur passionate about building amazing digital experiences",
    button: { title: "Get in Touch", url: "https://stack.je" },
    logo: {
      src: "https://placehold.co/128x128",
      alt: "Personal logo",
    },
    image: {
      src: "https://placehold.co/120x120",
      alt: "Profile picture",
    },
    backgroundImage: {
      src: "https://placehold.co/800x256",
      alt: "Background image",
    },
    socialLinks: [
      { platform: "instagram" as const, url: "https://instagram.com/john", displayName: "@john" },
      { platform: "x" as const, url: "https://x.com/john", displayName: "@john" },
      { platform: "pinterest" as const, url: "https://pinterest.com/john", displayName: "@john" },
      { platform: "email" as const, url: "mailto:john@example.com", displayName: "Email me" },
    ],
  },
  hero4: {
    brandTitle: "Personal Brand",
    title: "Sarah Johnson",
    description:
      "Award-winning photographer and visual storyteller capturing life's extraordinary moments",
    button: { title: "View Portfolio", url: "https://stack.je" },
    logo: {
      src: "https://placehold.co/128x128",
      alt: "Personal logo",
    },
    image: {
      src: "https://placehold.co/120x120",
      alt: "Profile picture",
    },
    backgroundImage: {
      src: "https://placehold.co/800x192",
      alt: "Background header",
    },
    socialLinks: [
      { platform: "instagram" as const, url: "https://instagram.com/sarah", displayName: "@sarah" },
      { platform: "pinterest" as const, url: "https://pinterest.com/sarah", displayName: "@sarah" },
      { platform: "x" as const, url: "https://x.com/sarah", displayName: "@sarah" },
      { platform: "email" as const, url: "mailto:sarah@example.com", displayName: "Hire me" },
    ],
  },
  hero5: {
    brandTitle: "TechCorp",
    title: "BIG BOLD HEADLINE",
    description:
      "Compelling description that explains value proposition and draws users in with modern design",
    button: { title: "Get Started", url: "https://stack.je" },
    logo: {
      src: "https://placehold.co/128x128",
      alt: "TechCorp logo",
    },
    image: {
      src: "https://placehold.co/600x800",
      alt: "Product showcase",
    },
    diagonalAngle: 20,
    socialLinks: [
      { platform: "x" as const, url: "https://x.com/techcorp", displayName: "@techcorp" },
      { platform: "instagram" as const, url: "https://instagram.com/techcorp", displayName: "@techcorp" },
      { platform: "email" as const, url: "mailto:hello@techcorp.com", displayName: "Contact us" },
    ],
  },
  links: {
    title: "Quick Access Links",
    description: "Essential resources and tools at your fingertips",
    links: [
      {
        title: "Featured Link 1",
        description: "",
        url: "https://stack.je",
        image: {
          src: "https://placehold.co/150",
          alt: "Featured Link",
        },
      },
      {
        url: "https://github.com",
        description: "Explore code repositories",
        image: {
          src: "https://placehold.co/150",
          alt: "GitHub",
        },
      },
      {
        title: "Featured Link 3",
        description: "",
        url: "https://stack.je",
        image: {
          src: "https://placehold.co/150",
          alt: "Featured Link 3",
        },
      },
    ],
  },
  features: {
    title: "Key Features",
    subtitle: "Discover what makes our product special",
    features: [
      {
        title: "Easy Integration",
        description: "Set up in minutes with our simple integration process",
        image: "https://placehold.co/150",
      },
      {
        title: "Powerful Analytics",
        description: "Get detailed insights into your performance",
        image: "https://placehold.co/150",
      },
      {
        title: "24/7 Support",
        description: "Our team is here to help you succeed",
        image: "https://placehold.co/150",
      },
    ],
  },
  text: {
    title: "Sample Title",
    subtitle: "Sample subtitle text goes here",
  },
  faq: {
    title: "Frequently Asked Questions",
    description: "Find answers to common questions about our service",
    faqs: [
      {
        question: "What is your service about?",
        answer:
          "Our service helps you create and manage beautiful landing pages easily.",
      },
      {
        question: "How do I get started?",
        answer:
          "Simply sign up for an account and follow our quick start guide.",
      },
    ],
  },
  faq2: {
    title: "Common Questions",
    description: "Everything you need to know about getting started with our platform",
    faqs: [
      {
        question: "Do you offer a free trial?",
        answer:
          "Yes! We offer a 14-day free trial with full access to all premium features. No credit card required to get started.",
      },
      {
        question: "How secure is my data?",
        answer:
          "We use enterprise-grade encryption and follow industry best practices. Your data is stored securely and never shared with third parties.",
      },
      {
        question: "Can I cancel anytime?",
        answer:
          "Absolutely! You can cancel your subscription at any time with no penalties or hidden fees. Your data remains accessible during the notice period.",
      },
      {
        question: "Do you provide customer support?",
        answer:
          "Yes, we offer 24/7 customer support via email and live chat. Premium users also get priority phone support and dedicated account managers.",
      },
      {
        question: "Is there a setup fee?",
        answer:
          "No setup fees! Our onboarding process is completely free, and we even provide personalized setup assistance for all new customers.",
      },
      {
        question: "What payment methods do you accept?",
        answer:
          "We accept all major credit cards, PayPal, and bank transfers for annual plans. All payments are processed securely through Stripe.",
      },
    ],
  },
  images: {
    title: "Image Gallery",
    description: "Showcase your visual content with elegant layouts",
    images: [
      {
        image: {
          src: "https://placehold.co/400x400",
          alt: "Sample Image 1",
        },
        caption: "Beautiful landscape photography",
      },
      {
        image: {
          src: "https://placehold.co/400x300",
          alt: "Sample Image 2",
        },
        caption: "Modern architecture design",
      },
      {
        image: {
          src: "https://placehold.co/300x400",
          alt: "Sample Image 3",
        },
        caption: "Creative artwork display",
      },
    ],
  },
  image4: {
    title: "Horizontal Gallery",
    description: "Swipe through images in a scrollable gallery - click to view full size",
    images: [
      {
        image: {
          src: "https://placehold.co/600x450",
          alt: "Nature Landscape 1",
        },
        caption: "Misty mountain peaks at sunrise",
      },
      {
        image: {
          src: "https://placehold.co/600x450",
          alt: "Urban Architecture 1",
        },
        caption: "Modern glass building facade",
      },
      {
        image: {
          src: "https://placehold.co/600x450",
          alt: "Abstract Art 1",
        },
        caption: "Colorful geometric patterns",
      },
      {
        image: {
          src: "https://placehold.co/600x450",
          alt: "Wildlife Photo 1",
        },
        caption: "Majestic eagle in flight",
      },
      {
        image: {
          src: "https://placehold.co/600x450",
          alt: "Ocean View 1",
        },
        caption: "Crystal clear tropical waters",
      },
    ],
  },
  image5: {
    title: "Seamless Gallery",
    description: "Borderless horizontal gallery with overlay captions - perfect for portfolios",
    images: [
      {
        image: {
          src: "https://placehold.co/800x600",
          alt: "Portfolio Work 1",
        },
        caption: "Creative Design Project",
      },
      {
        image: {
          src: "https://placehold.co/800x600",
          alt: "Portfolio Work 2",
        },
        caption: "Brand Identity Design",
      },
      {
        image: {
          src: "https://placehold.co/800x600",
          alt: "Portfolio Work 3",
        },
        caption: "Digital Art Installation",
      },
      {
        image: {
          src: "https://placehold.co/800x600",
          alt: "Portfolio Work 4",
        },
        caption: "Website UI/UX Design",
      },
      {
        image: {
          src: "https://placehold.co/800x600",
          alt: "Portfolio Work 5",
        },
        caption: "Photography Series",
      },
      {
        image: {
          src: "https://placehold.co/800x600",
          alt: "Portfolio Work 6",
        },
        caption: "Mobile App Interface",
      },
    ],
  },
  whatsapp: {
    whatsappNumber: "+1234567890",
    initialMessage: "Hi! I'm interested in learning more about your services.",
    buttonText: "Chat with us now",
    title: "Get in Touch",
    description: "Connect with us directly on WhatsApp for instant support and quick responses.",
  },
  tipping1: {
    title: "Buy Me a Teh Tarik! ☕",
    description: "Support my work with a donation",
    paymentMethod: "paynow" as const,
    payeeInfo: {
      paynow: {
        type: "MOBILE" as const,
        value: "+6591234567",
        recipientName: "John Doe",
      }
    },
    amounts: [5, 10, 20, 50],
    allowCustomAmount: true,
    minAmount: 1,
    maxAmount: 999,
    currency: "SGD",
    buttonText: "Generate PayNow QR",
    thankYouNote: "Thank you for your support! 🙏",
  },
  tipping2: {
    title: "Support My Content",
    description: "Every little bit helps keep the content coming!",
    paymentMethod: "paynow" as const,
    payeeInfo: {
      paynow: {
        type: "UEN" as const,
        value: "201912345K",
        recipientName: "Content Creator Pte Ltd",
      }
    },
    amounts: [3, 5, 10, 25, 100],
    allowCustomAmount: true,
    minAmount: 1,
    maxAmount: 500,
    currency: "SGD",
    buttonText: "Tip Now",
    thankYouNote: "Thank you for your support! 🙏",
  },
};
